import React from 'react';
// import { RunSheet } from 'src/models/RunSheet';
import FormRow from 'src/components/controls/forms/FormRow';
import { Controller, UseFormMethods } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import Landman from 'src/models/Landman';
import Select, { StylesConfig } from 'react-select';

interface IRunsheetDetailsProps extends Partial<Pick<UseFormMethods, 'register' | 'errors' | 'control'>> {
    projectStaff: Landman[];
}

const RunsheetDetails: React.FC<IRunsheetDetailsProps> = (props) => {
    const staffOptions: Array<{ value: number, label: string }> = props.projectStaff.map(u => { return { value: u.id, label: `${u.firstName} ${u.lastName}` }; });

    // TODO: Abstract this, and figure out a universal styling for it.
    const customStyles: StylesConfig<{ label: string; value: string | number }, false> = {
        control: (provided) => ({
            ...provided,
            minHeight: '30px',    // Set a smaller minHeight
            height: '30px',       // Force a smaller height
            padding: '0px',       // Remove internal padding to make it smaller
            marginTop: '1.8rem'   // Adjust dropdown position.
        }),
        valueContainer: (provided) => ({
            ...provided,
            padding: '0px 8px',   // Adjust padding to make the height smaller
            height: '30px',       // Force height for the container
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',        // Ensure no margins are added
            padding: '0px',       // Ensure no padding is added
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '30px',       // Force the height of the dropdown indicators
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0px',       // Remove extra padding from the dropdown arrow
        }),
    };

    const DateRow = (dateTitle: string, fieldName: string, userTitle: string) => {
        return (
            <FormRow style={{ display: 'flex', gap: '1rem' }}>
                <RHFInputBox name={`${fieldName}Date`} label={dateTitle} type="date" register={props.register} errors={props.errors} style={{ width: '100%' }} bodyStyle={{ width: '40%' }} />
                {/* <RHFSelect 
                    name={`${fieldName}UserId`}
                    label={userTitle} 
                    register={props.register} 
                    errors={props.errors} 
                    options={props.projectStaff.map(u => { return { value: u.id, label: `${u.firstName} ${u.lastName}` }; })}
                    style={{ width: '100%' }} 
                    bodyStyle={{ width: '60%' }}
                /> */}
                <Controller
                    name={`${fieldName}UserId`}
                    control={props.control}
                    defaultValue={null}
                    render={({ onChange, onBlur, value }) => (
                        <Select
                            value={staffOptions.find(so => so.value === value)}
                            onChange={(option) => onChange(option?.value ?? null)}                            
                            onBlur={onBlur}
                            placeholder={userTitle}
                            options={staffOptions}
                            isSearchable={true}
                            className="field"
                            styles={customStyles}
                            isClearable={true}
                        />
                    )}
                />
            </FormRow>
        );
    };

    return (
        <div>
            <div>
                <div style={{ border: '1px solid #ccc', padding: '1rem' }}>
                    <h5>
                        <span style={{ paddingLeft: '.5rem' }}>&middot; Runsheet Data</span>
                    </h5>
                    <div style={{ overflowY: 'auto', padding: '1rem' }}>
                        <RHFInputBox name="friendlyName" label="Runsheet Name" register={props.register} errors={props.errors} style={{ width: '100%' }} />
                        <RHFInputBox name="titleAttorney" label="Title Attorney" register={props.register} errors={props.errors} style={{ width: '100%' }} />
                        <RHFInputBox name="clientLandman" label="Client Landman" register={props.register} errors={props.errors} style={{ width: '100%' }} />
                        <RHFInputBox name="wellName" label="Well Name" register={props.register} errors={props.errors} style={{ width: '100%' }} />
                        <RHFInputBox name="documentNumber" label="Abstract / Doc #" register={props.register} errors={props.errors} style={{ width: '100%' }} />
                        {/* <FormTextBox name="documentName" label="Abstract / Title Opinion Name" /> */}
                        {/* <FormTextBox name="agreementNumber" label="Agreement Number" /> */}
                        {/* {DateRow('Target Completion', 'targetCompletionDate', 'Assigned By', 'targetCompletionDateUserId')} */}
                        <FormRow style={{ display: 'flex', gap: '1rem' }}>
                            <RHFInputBox name="statusTypeCheck" label="Status / Type Check" register={props.register} errors={props.errors} style={{ width: '100%' }} bodyStyle={{ width: '80%' }} />
                            {/* <RHFSelect
                                name={`statusTypeCheckAssignedByUserId`}
                                label="Assigned By"
                                register={props.register}
                                errors={props.errors}
                                options={props.projectStaff.map(u => { return { value: u.id, label: `${u.firstName} ${u.lastName}` }; })}
                                style={{ width: '100%' }}
                                bodyStyle={{ width: '60%' }}
                            /> */}
                            <Controller
                                name="statusTypeCheckAssignedByUserId"
                                control={props.control}
                                defaultValue={null}
                                render={({ onChange, onBlur, value }) => (
                                    <Select
                                        value={staffOptions.find(so => so.value === value) ?? null}
                                        onChange={(option) => onChange(option?.value ?? null)}
                                        onBlur={onBlur}
                                        placeholder={'Assigned By'}
                                        options={staffOptions}
                                        isSearchable={true}
                                        className="field"
                                        styles={customStyles}
                                        isClearable={true}
                                    />
                                )}
                            />
                        </FormRow>
                        {DateRow('Received From Client', 'receivedFromClient', 'Received By')}
                        {DateRow('Assigned To Landman', 'assignedToLandman', 'Assigned To')}
                        {DateRow('Received By Landman', 'receivedByLandman', 'Received By')}
                        {DateRow('Sent to DLC Office', 'sentToLandCompany', 'Sent By')}
                        {DateRow('Received by DLC Office', 'receivedByDlc', 'Received By')}
                        {DateRow('Sent to Client', 'sentToClient', 'Sent By')}
                        {DateRow('Title Opinion Received', 'titleOpinionReceived', 'Received By')}
                        {DateRow('Title Cleared', 'titleCleared', 'Cleared By')}
                        {DateRow('Client Requested Update', 'clientRequestedUpdate', 'Received By')}
                        {DateRow('Update Request Completed', 'updateRequestCompleted', 'Sent By')}
                        <br />
                        <FormRow>
                            {/* <FormTextBox style={{ width: '33%' }} name="unimpor" label="Percent of Tract" /> */}
                            <RHFCheckbox name="onHold" label="On Hold" register={props.register} errors={props.errors} bodyStyle={{ width: '70%' }} />
                            <RHFInputBox name="onHoldDate" label="On Hold Date" type="date" register={props.register} errors={props.errors} />
                        </FormRow>
                        <FormRow style={{ display: 'flex', gap: '1rem' }}>
                            <RHFTextArea
                                name="comments"
                                label="Comments"
                                register={props.register}
                                errors={props.errors}
                            />
                        </FormRow>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RunsheetDetails;



// WEBPACK FOOTER //
// ./src/components/project/sections/RunsheetDetails.tsx